(ns manatee.domain.external
  (:require [clojure.spec.alpha :as s]
            [clojure.spec.gen.alpha :as gen]
            [score-adjuster.model :as model]
            [utility-belt.uuid :refer [uuid-string?]]))

(s/def ::cefr-level #{"0" "Pre-A1" "A1" "A1+" "A2" "A2+" "B1" "B1+" "B2" "B2+" "C1" "C1+" "C2"})

(s/def :manatee.domain.external.linguaskill/score
  #{"no-meaningful-response"
    "off-topic"
    "malpractice"
    "1"
    "1.5"
    "2"
    "2.5"
    "3"
    "3.5"
    "4"
    "4.5"
    "5"
    "5.5"
    "6"})

(defn raw-score->cefr-level
  [raw-score raw-score-type]
  (->> raw-score
       (model/to-ces-score raw-score-type)
       (model/description-for :cefr-level)))

(s/def ::uuid-uuid uuid?)
(s/def ::uuid-string (s/with-gen uuid-string?
                       #(gen/fmap str (s/gen ::uuid-uuid))))

(s/def ::uuid (s/with-gen
                (s/or :uuid-uuid ::uuid-uuid
                      :uuid-string ::uuid-string)
                #(gen/fmap str (s/gen ::uuid-uuid))))

(def account-id-length 16)

(s/def ::account-id
  (s/with-gen
    (s/and string?
           #(= account-id-length (count %)))
    (fn []
      (gen/fmap #(apply str %)
                (gen/vector (gen/char-alphanumeric) account-id-length)))))

(s/def ::api-version
  (s/and string?
         #(re-matches #"[0-9]+\.[0-9]+\.[0-9]+" %)))

;; Answer & Submission
(s/def ::id ::uuid)
(s/def ::submission-id ::uuid)
(s/def ::answer-id ::uuid)
(s/def ::answer-ids (s/coll-of ::answer-id :min-count 1))
(s/def ::question-id ::uuid)
(s/def ::answer (s/keys :req-un [::id ::question-id ::question-number ::status]))
(s/def ::answers (s/coll-of ::answer :kind vector? :min-count 1))
(s/def ::part (s/int-in 1 6))

(s/def ::question-number (s/int-in 3 24))
(s/def ::assessment (s/double-in :min 0.0 :max 6.0 :NaN? false :infinite? false))
(s/def ::passing-assessment (s/double-in :min 2.0 :max 6.0 :NaN? false :infinite? false))
(s/def ::score (s/keys :req-un [::assessment]))
(s/def ::status #{:success})

(s/def ::results
  (s/coll-of
   (s/keys
    :req-un [::part
             ::status
             ::score
             ::answers])
   :count 1))

(s/def ::submission (s/keys :req-un [::id ::results]))

;; Question
(s/def ::image-urls
  (s/coll-of
   (s/and
    string?
    not-empty)))
(s/def ::speaking-time (s/int-in 0 61))
(s/def ::thinking-time (s/int-in 0 61))
(s/def ::text string?)
(s/def ::question
  (s/keys
   :opt-un [::speaking-time
            ::text
            ::thinking-time]
   :opt [::image-urls]))
